import { Injectable } from "@angular/core";
import { RequestData } from "src/app/common/models/request-data.model";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  constructor(private http: HttpClient) { }
  /**
   * 
   * get company settings
   */
  loadCompanySetting() {
    return this.http.get(environment.baseUrl + "company/get");
  }
  /**
  * @param serviceId
  * get order service timing info
  */
  getOrderServiceTimingByService(serviceId: number): any {
    return this.http.get<any>(
      environment.baseUrl +
      "company/get-service-time-slots?serviceId=" +
      serviceId
    );
  }
  /**
  * @param bodyParams
  * Calls the saveOrderServiceTimingData API to update the order service timing
  */
  saveOrderServiceTimingData(bodyParams: any): any {
    return this.http.post<any>(
      environment.baseUrl + "company/set-service-time-slots",
      bodyParams
    );
  }
  /**
   * @param requestParams
   * Calls the update API to update the company settings
   */
  updateCompanySettings(requestParams: any) {
    return this.http.post(
      environment.baseUrl + "company/save",
      requestParams
    );
  }

  setNotice(formData: any): any {
    return this.http.post<any>(
      environment.baseUrl + "company/set-notice",
      formData
    );
  }
  resetNotice(): any {
    return this.http.post(environment.baseUrl + "company/reset-notice",'');
  }

  loadBanners(){
    return this.http.post(environment.wsPhp + '/banner/get-list','')
  }

  addBanner(bannerData: any): Observable<any> {
    return this.http.post(environment.wsPhp + '/banner/add', bannerData, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
}

updateBanners(bannerData: any[]): Observable<any> {
  console.log(bannerData)
  return this.http.post(environment.wsPhp + '/banner/update', bannerData, {
      headers: {
          'Content-Type': 'application/json'
      }
  });
}

getBanner(id: number): Observable<any> {
  return this.http.get(environment.wsPhp + '/banner/get/' + id);
}

updateBanner(bannerId: number, bannerData: any): Observable<any> {
    console.log('Calling updateBanner API:', environment.wsPhp + '/banner/update/' + bannerId);
    console.log('With data:', bannerData);
    
    return this.http.put(environment.wsPhp + '/banner/update/' + bannerId, bannerData, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
}

deleteBanner(bannerId: number): Observable<any> {
    console.log('Calling delete API:', environment.wsPhp + '/banner/delete/' + bannerId);
    return this.http.delete(environment.wsPhp + '/banner/delete/' + bannerId);
}

updateBannerOrder(orderData: any[]): Observable<any> {
    console.log('Calling banner/update-order API:', environment.wsPhp + '/banner/update-order');
    console.log('Order data:', orderData);
    return this.http.post(environment.wsPhp + '/banner/update-order', orderData, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
}
}
